module.exports = __webpack_public_path__ + "static/media/icon-supplies-washcloth.9c5f9a4f.svg";